import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-grid">
        <div className="footer-column">
          <img src="img/contarte.jpg" alt="Contarte Logo" className="footer-logo" />
          <div className="footer-social">
            <a href="https://instagram.com/contarte_cultura" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="https://wa.me/3417040434" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
              <FaWhatsapp />
            </a>
          </div>
        </div>

        <div className="footer-column">
          <h4 className="footer-title azul">Sitio Web</h4>
          <Link to="/">Home</Link>
          <Link to="/cultura">Cultura en la casa</Link>
          <Link to="/eventos">Eventos</Link>
          <Link to="/recomendaciones">Recomendaciones</Link>
        </div>

        <div className="footer-column">
          <h4 className="footer-title azul">Contacto</h4>
          <Link to="https://api.whatsapp.com/send/?phone=3417040434&text&type=phone_number&app_absent=0" target="_blank"><p><FaWhatsapp /> 3417040434</p></Link>
          <Link to="https://www.instagram.com/contarte_cultura?igshid=ZDdkNTZiNTM%3D" target="_blank"><p><FaInstagram /> contarte_cultura</p></Link>
          <a href="mailto:contarte2023@gmail.com"><p>✉️ contarte2023@gmail.com</p></a>
          <Link to="https://www.whatsapp.com/channel/0029VabP1vxLCoX40bwvjF3D" target="_blank"><p>🧾 contarte (canal de WhatsApp)</p></Link>
        </div>
      </div>
      <p className="footer-copy">© {new Date().getFullYear()} Contarte</p>
    </footer>
  );
};

export default Footer;
